import React, { Component } from 'react';
import Table from './Table'
import { Card, CardBody} from 'reactstrap';
import './styles.scss'
import AddDocument from './components/modal'
import Download from './components/Download';


class Tracking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      shipment: "",
      shipmentDataPlane: "",
      comments: [],
      disabledView: false,
      disabledDownload: false,
      data: props.dataDocuments,
      load: false,
      columns:
        [
          { label: 'Document Name', key: 'NameDocumentHouse' },
          { label: 'Document Type', key: 'Type' },
          { label: 'Creation Date', key: 'CreationDateDocument' },
          {
            label: 'Download', key: 'URL', custom: (value) => {
              return (
                <Download file={value.URL} type={value.Type} name={value.NameDocumentHouse} action='download' />
              )
            }
          },
          {
            label: 'View', key: 'DocumentKeyAsString', custom: (value) => {
              return (
                <Download file={value.URL} type={value.Type} name={value.CreationDateDocument} action='visualization' />
              )
            }
          },
        ],
    };
  }

  componentWillReceiveProps = (nextProps) => {
    this.setState({
      data: nextProps.dataDocuments
    })

  }

  render() {
    return (
      <>
        <AddDocument GetDocumments={this.props.GetDocumments} idContainer={this.props.idContainer} />
        <Card className="myCard">
          <CardBody>
            <div className="row">
              <div className="col-12">
                <Table
                  columns={this.state.columns}
                  data={this.state.data}
                  itemsByPage={10}
                  options={{
                    large: false,
                    downloads: {
                      pdf: false,
                      xlsx: false
                    },
                    pagination: true,
                    search: true,
                  }}
                />
              </div>
            </div>
          </CardBody>
        </Card>
      </>
    );
  }
}

export default Tracking;
